import React from 'react';
import moment from 'moment';
import { Input, Tooltip, Select, DatePicker } from 'antd/lib';
import * as Icons from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;

export default ({ traspaso }) => {
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  };

  if (!traspaso) {
    return null;
  }

  return (
    <div>
      <Form style={{ marginTop: 50, marginRight: 40 }}>
        <FormItem
          {...formItemLayout}
          label={
            <span>
              Lugar
              <Tooltip title="Seleccione el organismo">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <Select
            showSearch
            style={{ width: 500, color: '#000000' }}
            placeholder="Seleccione un organismo"
            optionFilterProp="children"
            disabled={true}
            defaultValue={traspaso.organismo._id}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option key={traspaso.organismo._id} value={traspaso.organismo._id}>
              {traspaso.organismo.nombre}
            </Option>
          </Select>
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={
            <span>
              Fecha y Hora
              <Tooltip title="Fecha y hora que se efectuará el traspaso ">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <DatePicker
            showTime
            format="DD-MM-YYYY HH:mm"
            placeholder="Seleccionar Fecha y Hora"
            defaultValue={moment(traspaso.fechaEstimada)}
            disabled={true}
            style={{ color: '#000000' }}
          />
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Quien entrega
              <Tooltip title="Seleccione el juez saliente">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <Select
            showSearch
            style={{ width: 500, color: '#000000' }}
            placeholder="Seleccione quien entrega"
            optionFilterProp="children"
            disabled={true}
            defaultValue={traspaso.usuarioSaliente._id}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option
              key={traspaso.usuarioSaliente._id}
              value={traspaso.usuarioSaliente._id}
            >
              {traspaso.usuarioSaliente.nombre +
                ' ' +
                traspaso.usuarioSaliente.apellido}
            </Option>
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Quien recibe
              <Tooltip title="Seleccione el juez entrante">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <Select
            showSearch
            style={{ width: 500, color: '#000000' }}
            placeholder="Seleccione quien recibe"
            disabled={true}
            defaultValue={traspaso.usuarioEntrante._id}
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            <Option
              key={traspaso.usuarioEntrante._id}
              value={traspaso.usuarioEntrante._id}
            >
              {traspaso.usuarioEntrante.nombre +
                ' ' +
                traspaso.usuarioEntrante.apellido}
            </Option>
          </Select>
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Motivo
              <Tooltip title="Motivo del traspaso ">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <Input
            defaultValue={traspaso.motivo}
            disabled={true}
            style={{ color: '#000000' }}
          />
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={
            <span>
              Observaciones
              <Tooltip title="Observaciones del traspaso ">
                <Icons.QuestionCircleOutlined />
              </Tooltip>
            </span>
          }
        >
          <TextArea
            style={{ color: '#000000' }}
            defaultValue={traspaso.observacionEntrega}
            disabled={true}
            rows={6}
          />
        </FormItem>
      </Form>
    </div>
  );
};
